import { render } from "./App.vue?vue&type=template&id=4d4f0d54"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4d4f0d54&lang=css"

import exportComponent from "E:\\官网\\zhsk-officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__